import React from 'react'
import styles from './index.module.css'
import { Link } from 'gatsby'
import picture from '../common/picture.jpeg'
import howlong from './howlong_app.jpg'

export default ({ children, nav, headerLink = '/' }) => {
  return (
    <div className={styles.container}>
      <header className={styles.blogHeader}>
        <a href={headerLink}>
          <img src={picture} alt="Łukasz Makuch" className={styles.picture} />
          <h1>Łukasz Makuch</h1>
        </a>
      </header>
      <div className={styles.center}>
        <div className={styles.contentAndSidebar}>
          <main className={styles.mainContainer}>{children}</main>
          <section className={styles.sidebar}>
            <div className={styles.sidebarWrapper}>
              <h2 className={styles.sidebarHeader}>
                From the author of this blog
              </h2>
              <ul className={styles.sidebarList}>
                <li>
                  <a href="https://howlong.app?utm_source=coder&utm_medium=sidebar&utm_campaign=not_against">
                    <img
                      src={howlong}
                      className={styles.fromTheSameAuthorImg}
                      alt="howlong.app - a timesheet built for freelancers, not against them!"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
      {nav && <nav className={styles.blogNav}>{nav}</nav>}
    </div>
  )
}
